import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./styles/wp-content.css";
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { PublicContent } from './context/PublicContent';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <PublicContent.Provider value={window.__PAGE_DATA__ || { post: null }}>
      <BrowserRouter><App /></BrowserRouter>
    </PublicContent.Provider>
  </React.StrictMode>
);

if (container.dataset.prerendered === 'true') {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// console.log(reportWebVitals());
